import React from 'react';
import { METALS, metalFill, planTypeColors } from './hsColors';

// =============================================================================
// HealthSherpa badges (5.18.0, 5.18.1) — used by the plan list, the large plan view and Compare.
// Sized in em, so they scale with whatever font-size their container has (the list's text-size slider).
//   MetalBadge: FILLED (Gold / Silver / Platinum with a subtle two-tone sheen + thin border), dark readable
//               text, small rounded. Unknown metal -> plain text, no badge.
//   TypeBadge:  OUTLINED (transparent fill), capitals — never mistaken for a metal badge.
// Colours live in hsColors.js.
// =============================================================================

const prettyCode = (s) => String(s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function MetalBadge({ code, darkMode, label, wrap }) {   // wrap: may break onto 2 lines (plan list)
  const key = String(code || '').toLowerCase();
  const text = label || prettyCode(code);
  if (!code) return <span>—</span>;
  const tone = METALS[key];
  if (!tone) return <span>{text}</span>;
  const t = darkMode ? tone.dark : tone.light;
  return (
    <span style={{ display: 'inline-block', background: metalFill(t), color: t.text, border: `1px solid ${t.border || t.bg}`, borderRadius: '0.35em',
      padding: '0.12em 0.55em', fontSize: '0.9em', fontWeight: 600, lineHeight: 1.35, whiteSpace: wrap ? 'normal' : 'nowrap' }}>
      {text}
    </span>
  );
}

export function TypeBadge({ code, darkMode }) {
  if (!code) return <span>—</span>;
  const col = planTypeColors(code)[darkMode ? 'dark' : 'light'];
  return (
    <span style={{ display: 'inline-block', border: `1px solid ${col}`, color: col, background: 'transparent', borderRadius: '0.35em',
      padding: '0.12em 0.5em', fontSize: '0.9em', fontWeight: 600, letterSpacing: '0.04em', lineHeight: 1.35, whiteSpace: 'nowrap' }}>
      {String(code).toUpperCase()}
    </span>
  );
}
